import { render, staticRenderFns } from "./QuestionLabelling.vue?vue&type=template&id=39d412d2&scoped=true"
import script from "./QuestionLabelling.vue?vue&type=script&lang=js"
export * from "./QuestionLabelling.vue?vue&type=script&lang=js"
import style0 from "./QuestionLabelling.vue?vue&type=style&index=0&id=39d412d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d412d2",
  null
  
)

export default component.exports